<script>
    import appConfig from '@src/app.config'
	import Layout from '@layouts/newdefaultform'
	import PageHeader from '@components/page-header'
	import { authComputed } from '@state/helpers'	
	import listManage from '@components/list-manage'
	import Confirmation from '@components/confirmation'
	import Information from '@components/information'
	import Spinner from '@components/spinner'
	import { giftlistApi } from '@router/apiFiles/giftlistApi'
	import { creditApi } from '@router/apiFiles/creditApi'
	import axios from 'axios'

    /**
     * Page
     */
    export default {
        page: {
            title: 'Relatórios',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: {
            Layout, PageHeader, listManage, Confirmation, Information, Spinner
        },
        data() {
            return {
                title: 'Relatórios',
                items: [
                    {
                        text: 'LaVille',
                        href: '/',
                    },
                    {
                        text: 'Listas',
                        href: '/',
                    },
                    {
                        text: 'Relatórios',
                        active: true,
                    },
                ],
				begin: '',
				end: ''
            }
        },
        mounted() {
            this.fetchData()
        },
        methods: {
            async fetchData() {
				this.begin = this.addDays(new Date(), -30);
				this.end = this.addDays(new Date(), 1);
			},
			addDays(date, days) {
				var result = new Date(date);
  				result.setDate(result.getDate() + days);
  				return result;
			}
        }
    }
</script>

<template>
	<Layout>
		<Spinner :loading="isBusy" />
		<PageHeader :title="title" :items="items" />

		<div class="row">			
			<div class="col-md-8 offset-md-2">
				<div class="card">
					<div class="card-header custom">
					</div>
					<div class="card-body pt-2 pb-2">


						<div class="row py-1 centered-flex">
							<div class="col-md-6">
								<div class="form-group mb-3">
									<label>Inicio</label>
									<flat-pickr
										v-model="begin"
										class="form-control"
										name="begin"
									></flat-pickr>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group mb-3">
									<label>Fim</label>
									<flat-pickr
										v-model="end"
										class="form-control"
										name="end"
									></flat-pickr>
								</div>
							</div>
						</div>

						<div class="row py-1 centered-flex">
							<b-button class="m-2" variant="primary" :href="'/api/v1/giftlist/GiftlistsResume?begin=' + begin + '&end=' + end" target="_self"><i class="uil uil-file-download-alt"></i> Resumo das listas</b-button>
							<b-button class="m-2" variant="primary" :href="'/api/v1/giftlist/GiftlistMostGifted?begin=' + begin + '&end=' + end" target="_self"><i class="uil uil-file-download-alt"></i> Mais presenteados</b-button>
							<b-button class="m-2" variant="primary" :href="'/api/v1/giftlist/GiftlistMostRedempted?begin=' + begin + '&end=' + end" target="_self"><i class="uil uil-file-download-alt"></i> Mais resgatados</b-button>
						</div>

					</div>
				</div>				
			</div>			
		</div>
		
  </Layout>
</template>

<style>


.ext {
    text-align: center
}

.int {
    margin: 0 auto;
    text-align: left;
    position: relative;
    width: 1170px
}

.centered-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

